const localStorageData = {
  getData: (pageType) => {
    try {
      const item = localStorage.getItem(pageType);
      return item ? JSON.parse(item) : {}
    } catch (e) {
      console.error(`Failed to get stored widths for ${pageType}:`, e);
      return {};
    }
  },
  setData: (pageType, value) => {
    try {
      localStorage.setItem(pageType, JSON.stringify(value)); 
    } catch (e) {
      console.error(`Failed to set stored widths for ${pageType}:`, e);
    }
  }
}


export default localStorageData;